export type UserDetailSectionId =
  | 'profile'
  | 'security'
  | 'staff'
  | 'pharmacies'
  | 'geo'
  | 'mail'
  | 'biometrics'
  | 'sessions'
  | 'danger';

export const ZERDE_PRIMARY = '#1570ef';
export const ZERDE_EMERALD = '#047857';

export interface SectionNavItem {
  id: UserDetailSectionId;
  label: string;
}

// Какие из секций видны, решает карточка по флагам сервера - здесь только порядок и названия
export const USER_DETAIL_NAV_ITEMS: SectionNavItem[] = [
  { id: 'profile', label: 'Профиль' },
  { id: 'security', label: 'Доступ и безопасность' },
  { id: 'staff', label: 'Сотрудники точки' },
  { id: 'pharmacies', label: 'Подчиненные аптеки' },
  { id: 'geo', label: 'Геолокация' },
  { id: 'mail', label: 'Корпоративная почта' },
  { id: 'biometrics', label: 'Биометрия' },
  { id: 'sessions', label: 'Сессии и активность' },
  { id: 'danger', label: 'Опасная зона' }
];
